import { render, staticRenderFns } from "./PTAddressPost.vue?vue&type=template&id=fb8c8582"
import script from "./PTAddressPost.vue?vue&type=script&lang=js"
export * from "./PTAddressPost.vue?vue&type=script&lang=js"
import style0 from "./PTAddressPost.vue?vue&type=style&index=0&id=fb8c8582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports